import React from 'react';
import { ViewState } from '../../types';
import { ReactComponent as MainChartIcon } from '../../../../assets/icons/StockChart/analyst-icon.svg';
import { ReactComponent as TAIcon } from '../../../../assets/icons/StockChart/icon_viewta.svg';
import { ReactComponent as TrendlinesIcon } from '../../../../assets/icons/StockChart/trendlines.svg';
import { ReactComponent as TrackerIcon } from '../../../../assets/icons/StockChart/icon_viewpricetracker.svg';
import { ReactComponent as CrosshairIcon } from '../../../../assets/icons/StockChart/icon_viewcrosshair.svg';
import { ReactComponent as TooltipIcon } from '../../../../assets/icons/StockChart/message-2-line.svg';
import { ReactComponent as ScrollerIcon } from '../../../../assets/icons/StockChart/timeline-scroller.svg';
import SettingsPopup from '../common/SettingsPopup';
import SettingsCheckbox from '../common/SettingsCheckbox';
import '../../../../Components/Common/typography.css';
import './ViewSettings.css';

interface ViewSettingsProps {
  view: ViewState;
  onChange: (view: ViewState) => void;
}

const VIEW_ITEMS: {
  key: keyof ViewState;
  label: string;
  icon: React.ReactNode;
}[] = [
  { key: 'showMainChart', label: 'Show main chart', icon: <MainChartIcon /> },
  { key: 'showTA', label: 'Show technical analysis', icon: <TAIcon /> },
  { key: 'showTrendlines', label: 'Show trendlines', icon: <TrendlinesIcon /> },
  { key: 'showTracker', label: 'Show price tracker', icon: <TrackerIcon /> },
  { key: 'showCrosshair', label: 'Show crosshair', icon: <CrosshairIcon /> },
  {
    key: 'showCrosshairTooltip',
    label: 'Show crosshair tooltip',
    icon: <TooltipIcon />,
  },
  {
    key: 'showTimelineScroller',
    label: 'Show timeline scroller',
    icon: <ScrollerIcon />,
  },
];

const ViewSettings: React.FC<ViewSettingsProps> = ({ view, onChange }) => {
  const toggle = (key: keyof ViewState) => {
    onChange({ ...view, [key]: !view[key] });
  };

  return (
    <SettingsPopup className="view-settings-popup">
      {VIEW_ITEMS.map(({ key, label, icon }) => (
        <div
          key={key}
          className={`view-settings-row${view[key] ? ' view-settings-row-active' : ''}`}
          onClick={() => toggle(key)}
        >
          <SettingsCheckbox checked={view[key]} onChange={() => toggle(key)} />
          <span className="view-settings-icon">{icon}</span>
          <span className="body-m-regular">{label}</span>
        </div>
      ))}
    </SettingsPopup>
  );
};

export default ViewSettings;
